import styled from 'styled-components';
import { ThemeColours } from '../../../../common/styles/ThemeColours';
import {
  FontWeight,
  FONT_STACK,
  FontSize,
  LineHeight,
  BorderRadius,
} from '../../../../common/styles/constants';
import { onMobile } from '../../../../common/styles/onMobile';

export const SidebarFilterTitle = styled.div`
  ${FONT_STACK};
  background-color: ${ThemeColours.mono100};
  color: ${ThemeColours.mono900};
  font-size: ${FontSize.REGULAR};
  font-weight: ${FontWeight.SEMI_BOLD};
  line-height: ${LineHeight.REGULAR};
  padding: 20px;
`;

export const StyledSidebar = styled.div`
  border: 1px solid ${ThemeColours.mono100};
  border-radius: ${BorderRadius.MEDIUM};
  margin-bottom: 10px;
  margin-top: 10px;

  ${onMobile} {
    border: none;
    box-sizing: border-box;
    padding-left: 16px;
    padding-right: 16px;
  }
`;
